<template>
    <component
        :is="link != null ? 'a' : 'div'"
        :href="link"
        :target="link != null ? '_blank' : undefined"
        v-show="modelValue.scoreNumber != null"
        :class="{
            'trustpilot-banner': true,
            'trustpilot-banner--inverted': invertedColors,
            'trustpilot-banner--desktop': !mobile,
        }"
    >
        <strong class="trustpilot-score-text">{{
            modelValue.scoreText
        }}</strong>
        <img
            class="trustpilot-logo"
            :alt="modelValue.logoAltText ?? 'trustpilot'"
            :src="invertedColors ? invertedTrustpilotBanner : trustpilotBanner"
            width="74.11"
            height="18"
        />
        <div class="break" v-if="mobile"></div>
        <img
            v-if="imageUrl != null"
            :alt="modelValue.scoreAltText ?? modelValue.scoreText"
            :src="imageUrl"
            class="trustpilot-stars"
            :width="mobile ? 150 : 96"
            :height="mobile ? 28.13 : 18"
        />
        <span class="trustpilot-score-number">{{
            formattedNumber(modelValue.scoreNumber ?? 0)
        }}</span>
        <div class="break" v-if="mobile"></div>
        <span
            v-if="
                mobile && modelValue.reviews != null && modelValue.reviews > 0
            "
            class="trustpilot-review-count"
            >+{{ modelValue.reviews }}
            {{ labels.topSite.trustpilotReviews }}</span
        >
    </component>
</template>

<style lang="scss">
.trustpilot-banner {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    margin-bottom: 8px;
    font-size: 12px;
    flex-wrap: wrap;
    margin-top: 15px;

    .trustpilot-score-number {
        font-size: 12px;
        color: #4f4f4f;
        margin-top: 0.5em;
        margin-left: 0.5em;
    }
    .trustpilot-score-text {
        font-weight: 900;
    }
    .trustpilot-stars {
        margin-top: 0.5em;
    }
    .break {
        flex-basis: 100%;
    }

    .trustpilot-logo {
        margin-left: 0.5em;
    }

    .trustpilot-review-count {
        margin-top: 0.5em;
    }

    &--desktop {
        margin-top: 0;
        flex-wrap: nowrap;
        justify-content: center;

        .trustpilot-score-number {
            font-size: 10px;
            color: #4f4f4f;
        }

        .trustpilot-score-text: {
            order: 1;
        }

        .trustpilot-stars {
            order: 2;
            margin-top: 0;
            margin-left: 0.5em;
        }

        .trustpilot-score-number {
            order: 3;
            margin-top: 0;
        }

        .trustpilot-logo {
            order: 4;
        }
    }

    &--inverted {
        .trustpilot-score-number {
            color: white;
        }
        .trustpilot-score-text {
            color: white;
        }
        .trustpilot-review-count {
            color: white;
        }
    }
}
</style>

<script lang="ts">
export default {
    compatConfig: {
        MODE: 3,
    },
};
</script>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import labels from "../../shared/labels";
import { type TrustpilotData } from "../top-site/trustpilot-data";
import trustpilotBanner from "./trustpilot-logo.svg";
import invertedTrustpilotBanner from "./trustpilot-logo-inverted.svg";
import * as stars from "./stars-asset";

const props = defineProps({
    modelValue: {
        type: Object as PropType<TrustpilotData>,
        required: true,
    },
    mobile: Boolean,
    invertedColors: Boolean,
});

const format = Intl.NumberFormat("da-DK");

function formattedNumber(n: number) {
    return format.format(n);
}

const link = computed(() => {
    if (props.modelValue.link == null) return undefined;
    if (props.modelValue.link == "") return undefined;
    return props.modelValue.link;
});

function roundStars(n: number) {
    return Math.round(n / 0.5) * 0.5;
}

const imageUrl = computed(() => {
    if (props.modelValue.scoreNumber == null) {
        return undefined;
    }
    switch (roundStars(props.modelValue.scoreNumber)) {
        case 1:
            return stars.stars_1;
        case 1.5:
            return stars.stars_1_5;
        case 2:
            return stars.stars_2;
        case 2.5:
            return stars.stars_2_5;
        case 3:
            return stars.stars_3;
        case 3.5:
            return stars.stars_3_5;
        case 4:
            return stars.stars_4;
        case 4.5:
            return stars.stars_4_5;
        case 5:
            return stars.stars_5;
    }
    return undefined;
});
</script>
